import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Box, AppBar, Toolbar, Typography, List, ListItemButton, ListItemText, Button, Divider } from '@mui/material';
import { useStaff } from '../contexts/StaffContext';
import { hasPermission, StaffPermission } from '../utils/rolePermissions';

const navItems: Array<{ label: string; path: string; permission?: StaffPermission }> = [
  { label: 'Dashboard', path: '/staff/dashboard' },
  { label: 'Students', path: '/staff/students', permission: 'manage_students' },
  { label: 'Term History', path: '/staff/term-history', permission: 'manage_students' },
  { label: 'Materials', path: '/staff/materials', permission: 'manage_students' },
  { label: 'Subjects', path: '/staff/subjects', permission: 'manage_students' },
  { label: 'Quizzes', path: '/staff/quizzes', permission: 'manage_students' },
  { label: 'Assignments', path: '/staff/assignments', permission: 'manage_students' },
  { label: 'Grading', path: '/staff/grading', permission: 'manage_students' },
  { label: 'Attendance', path: '/staff/attendance', permission: 'manage_students' },
  { label: 'Payments', path: '/staff/payments', permission: 'view_payments' },
];

const StaffLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { staff, logout } = useStaff();
  const location = useLocation();

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <AppBar position="fixed" color="primary" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Typography variant="h6">School Staff Portal</Typography>
          <Box>
            {staff?.name && (
              <Typography component="span" sx={{ mr: 2 }}>
                {staff.name} ({staff.role})
              </Typography>
            )}
            <Button color="inherit" onClick={logout}>
              Logout
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      <Box component="nav" sx={{ width: 240, flexShrink: 0, mt: 8, bgcolor: 'background.paper', borderRight: 1, borderColor: 'divider' }}>
        <List>
          {navItems
            .filter((item) => !item.permission || (staff && hasPermission(staff.role, item.permission)))
            .map((item) => (
              <ListItemButton
                key={item.path}
                component={RouterLink}
                to={item.path}
                selected={location.pathname === item.path}
              >
                <ListItemText primary={item.label} />
              </ListItemButton>
            ))}
        </List>
        <Divider />
        <Box sx={{ p: 2 }}>
          <Typography variant="body2" color="text.secondary">
            Use the menu to access staff tools based on your permissions.
          </Typography>
        </Box>
      </Box>

      <Box component="main" sx={{ flexGrow: 1, p: 3, mt: 8 }}>
        {children}
      </Box>
    </Box>
  );
};

export default StaffLayout;
